export const COLLEGE_LABEL_PROPERTIES = [  { key: "name", type: "String" },];
export interface CollegeProperties {
  name: string;
}